import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiLinux,
  SiVisualstudiocode,
  SiJupyter,
  SiPostman,
  SiHeroku,
  SiIntellijidea,
  SiAnaconda,
  SiDocker,
  SiKubernetes
} from "react-icons/si";

import {AiFillGithub} from "react-icons/ai";

function handleClick(url) {
  window.open(url, '_blank').focus();
}

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col onClick={() => handleClick("https://www.linux.org/")} xs={4} md={2} className="tech-icons">
        <SiLinux />
      </Col>
      <Col onClick={() => handleClick("https://visualstudio.microsoft.com/")} xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
      <Col onClick={() => handleClick("https://jupyter.org/")} xs={4} md={2} className="tech-icons">
        <SiJupyter />
      </Col>
      <Col onClick={() => handleClick("https://www.postman.com/")} xs={4} md={2} className="tech-icons">
        <SiPostman />
      </Col>
      <Col onClick={() => handleClick("https://heroku.com")} xs={4} md={2} className="tech-icons">
        <SiHeroku />
      </Col>
      <Col onClick={() => handleClick("https://www.jetbrains.com/idea/")} xs={4} md={2} className="tech-icons">
        <SiIntellijidea />
      </Col>
      <Col onClick={() => handleClick("https://www.anaconda.com/")} xs={4} md={2} className="tech-icons">
        <SiAnaconda />
      </Col>
      <Col onClick={() => handleClick("https://www.docker.com/")} xs={4} md={2} className="tech-icons">
        <SiDocker />
      </Col>
      <Col onClick={() => handleClick("https://kubernetes.io/")} xs={4} md={2} className="tech-icons">
        <SiKubernetes />
      </Col>
      <Col onClick={() => handleClick("https://github.com/")} xs={4} md={2} className="tech-icons">
        <AiFillGithub />
      </Col>
      
      
    </Row>
  );
}

export default Toolstack;
